// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DjwDq","label":"styles_label__3zL1c"};